<template>
  <kst-table paginated view-mode
    :data="items"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      field="Name"
      :label="Catalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      cell-class="ks-col-alias"
      field="Alias"
      :label="Catalog.Alias.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      field="Address"
      :label="VendorAddressCatalog.Address.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="VendorAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactMobile"
      :label="VendorAddressCatalog.ContactMobile.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="VendorAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactPhone"
      :label="VendorAddressCatalog.ContactPhone.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="VendorAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactEmail"
      :label="VendorAddressCatalog.ContactEmail.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="VendorAddressCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import Catalog from "../VenCatalog.js";
import VendorAddressCatalog from "../VenaCatalog.js";

export default {
  props: {
    items: Array,
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    VendorAddressCatalog: VendorAddressCatalog
  })
}
</script>